import { useState } from 'react'
import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { errorMessage, successMessage } from 'lib/flash-message'
import Quantity from 'components/quantity'
import onCurrentUserExternalLogin from 'shared/utils/onCurrentUserExternalLogin/onCurrentUserExternalLogin'
import * as blUrls from 'lib/urls'
import AddFavorModal from './addFavorModal'

const FavorActions = ({
  PubSub,
  favor,
  addToRegistry,
  addedToRegistry,
  currentUserPresent,
  currentRegistryTitle,
  currentRegistryUrlSlug,
}) => {
  const [quantity, setQuantity] = useState(1)
  const [showModal, setShowModal] = useState(false)
  const [added, setAdded] = useState(addedToRegistry)
  const [addingToRegistry, setAddingToRegistry] = useState(false)

  const openModal = () => {
    setShowModal(true)
    setAddingToRegistry(true)
  }

  const closeModal = () => {
    setShowModal(false)
    setAddingToRegistry(false)
  }

  const addFavorToRegistry = (description) => {
    setShowModal(false)
    addToRegistry({ quantity, description })
      .then((resp) => {
        const title = resp?.regItem?.title
        const successMessageText = `${
          title || 'Item'
        } added to <a href="/${currentRegistryUrlSlug}">${
          currentRegistryTitle || 'your registry'
        }</a>!`

        setAdded(true)
        setAddingToRegistry(false)
        successMessage(successMessageText)
      })
      .catch(() => {
        setAddingToRegistry(false)
        errorMessage()
      })
  }

  const handleAddToRegistry = () => {
    if (currentUserPresent) {
      openModal()
    } else {
      window.open(blUrls.loginPathAsPopup, '_blank')

      onCurrentUserExternalLogin(openModal)
    }
  }

  return (
    <div>
      <Quantity
        min={1}
        unlimited
        value={quantity}
        className="mtm mbl"
        onChange={setQuantity}
      />
      <InfoButton
        block
        className="mbm"
        onClick={handleAddToRegistry}
        submitting={addingToRegistry}
      >
        {added ? '✓ Added!' : 'Add to Babylist'}
      </InfoButton>
      {showModal && (
        <AddFavorModal
          favor={favor}
          onHide={closeModal}
          onConfirm={addFavorToRegistry}
        />
      )}
    </div>
  )
}

FavorActions.propTypes = {
  favor: PropTypes.string.isRequired,
  addToRegistry: PropTypes.func.isRequired,
  addedToRegistry: PropTypes.bool.isRequired,
  currentUserPresent: PropTypes.bool.isRequired,
  currentRegistryTitle: PropTypes.string,
  currentRegistryUrlSlug: PropTypes.string,
  PubSub: PropTypes.shape({
    publish: PropTypes.func.isRequired,
  }).isRequired,
}

export default FavorActions
